<template>
	<div>
		<div class="lmy-mask-s" @click="data.show=false"></div>
		<transition  name="slideindown" >
		    <div class="lmy-filter-select lmy-filter-star" v-if="data.show" style="top: initial;bottom: 0">
		        <div class="filter-select-title price-select">价格</div>
		        <ul class="filter-select-content">
		            <li class="item" @click="selectPrice('',150,'¥150以下')">    <div>¥150以下</div></li>
		            <li class="item" @click="selectPrice(150,300,'¥150-300')">  <div>¥150-300</div></li>
		            <li class="item" @click="selectPrice(300,600,'¥300-600')">  <div>¥300-600</div></li>
		            <li class="item" @click="selectPrice(600,1000,'¥600-1000')"><div>¥600-1000</div></li>
		            <li class="item" @click="selectPrice(1000,'','¥1000以上')">  <div>¥1000以上</div></li>
		        </ul>
		        <div class="filter-select-title price-select">星级</div>
		        <ul class="filter-select-content star-select-content">
		            <li class="item" @click="selectStar(1,'二星/经济')"><div>二星/经济</div></li>
		            <li class="item" @click="selectStar(2,'三星/舒适')"><div>三星/舒适</div></li>
		            <li class="item" @click="selectStar(3,'四星/高档')"><div>四星/高档</div></li>
		            <li class="item" @click="selectStar(4,'五星/豪华')"><div>五星/豪华</div></li>
		        </ul>
		        <div class="filter-select-footer">
		            <div class="filter-select-btn" @click="reset">重置</div>
		            <div class="filter-select-btn complete" @click="data.show=false">完成</div>
		        </div>
				<!-- <div class="filter-select-footer">
					<div class="reset" @click="reset">重置</div>
					<div class="finish" @click="data.show=false">完成</div>
				</div> -->
		    </div>
		</transition>
	</div>
	
</template>
<script>
	export default{
		name:'star',
		props:{
			starData:{
				type:Object,
				default:()=>{
					return{}
				}
			}
		},
		data(){
			return{
				data:{}
			}
		},
		watch:{
			starData(val){
				this.data=val;

			}
		},
		methods:{
			reset(){
				this.$emit('selectStar','','');
				this.$emit('selectPrice','','','');
			},
			selectStar(star,name){
				this.$emit('selectStar',star,name)

			},
			selectPrice(min,max,name){
				this.$emit('selectPrice',min,max,name)

			}

		},
		mounted(){
			this.data=this.starData;
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/star.vue